import getEdgesForNodes from "Areas/Documents/graph/utils/getEdgesForNodes";
import morphLayout from "Areas/Documents/graph/utils/morphLayout";
import debounce from "lodash/debounce";
import { IEdge, INode } from "yfiles";
import buildChangeEdgesCallback from "./buildChangeEdgesCallback";
import buildChangeNodesCallback from "./buildChangeNodesCallback";
export default (graphComponentRef, inputMode, graphReadyRef, layoutAlgorithmRef, onChangeModel, onChangeZoom, onChangeSelected) => {
    var _a, _b, _c;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return;
    graphComponentRef.current.graph.addNodeRemovedListener((sender, evt) => {
        if (evt.item instanceof INode) {
            const node = evt.item;
            node.labels.toArray().forEach(label => {
                sender.remove(label);
            });
        }
    });
    graphComponentRef.current.graph.addEdgeCreatedListener((_, evt) => {
        var _a, _b, _c, _d;
        if (evt.item instanceof IEdge) {
            const edge = evt.item;
            if (!edge.tag && ((_b = (_a = edge.sourceNode) === null || _a === void 0 ? void 0 : _a.tag) === null || _b === void 0 ? void 0 : _b.NodeId) && ((_d = (_c = edge.targetNode) === null || _c === void 0 ? void 0 : _c.tag) === null || _d === void 0 ? void 0 : _d.NodeId)) {
            }
        }
    });
    if (onChangeSelected) {
        const itemSelectionChangedListener = debounce((sender) => {
            onChangeSelected &&
                onChangeSelected(sender.selectedNodes.toArray(), sender.selectedEdges.toArray());
        }, 10);
        graphComponentRef.current.selection.addItemSelectionChangedListener(itemSelectionChangedListener);
    }
    if (onChangeZoom)
        (_c = (_b = graphComponentRef.current.canvasContext) === null || _b === void 0 ? void 0 : _b.canvasComponent) === null || _c === void 0 ? void 0 : _c.addZoomChangedListener((sender) => {
            onChangeZoom && onChangeZoom(sender.zoom);
        });
    if (onChangeModel) {
        const changeNodeSourceListener = buildChangeNodesCallback(graphReadyRef, onChangeModel, 100);
        graphComponentRef.current.graph.addNodeCreatedListener(changeNodeSourceListener);
        graphComponentRef.current.graph.addNodeRemovedListener(changeNodeSourceListener);
        const changeNodeSourceTagsListener = buildChangeNodesCallback(graphReadyRef, onChangeModel, 50);
        graphComponentRef.current.graph.addNodeTagChangedListener(changeNodeSourceTagsListener);
        const changeEdgeSourceListener = buildChangeEdgesCallback(graphReadyRef, onChangeModel, 100);
        graphComponentRef.current.graph.addEdgeRemovedListener(changeEdgeSourceListener);
    }
    if (inputMode === null || inputMode === void 0 ? void 0 : inputMode.moveInputMode) {
        inputMode.moveInputMode.addDragFinishedListener(() => {
            var _a, _b;
            if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection) || !((_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.graph))
                return;
            const edges = getEdgesForNodes(graphComponentRef, graphComponentRef.current.selection.selectedNodes.toArray());
            if (!edges.size)
                return;
            morphLayout(graphComponentRef, layoutAlgorithmRef, null, edges);
        });
    }
    if (inputMode) {
        inputMode.addQueryItemToolTipListener((_, evt) => {
            if (evt.handled) {
                return;
            }
            const hitNode = evt.item;
            if (hitNode === null || hitNode === void 0 ? void 0 : hitNode.tag) {
                const documentObject = hitNode === null || hitNode === void 0 ? void 0 : hitNode.tag;
                evt.toolTip =
                    documentObject.Name +
                        (documentObject.GroupName ? `\n(${documentObject.GroupName})` : "");
                evt.handled = true;
            }
        });
    }
};
